var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"medium"}},_vm._l((_vm.matches),function(match,index){return _c('match',{key:index,attrs:{"match":match}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }